/**
 * This component takes a sentence and a term to highlight within that sentence.
 */
import styled from "styled-components";
import { escapeRegexString } from "app/services/segments/segmentsProcessor/segmentsKeywordsVariables";

const DefaultHighlight = styled.span`
    font-weight: 700;
`;

interface HighlightTermProps {
    sentence: string;
    highlightTerm: string;
    HighlightComponent?: React.ComponentType<{ children: React.ReactNode }>;
}

const HighlightTerm: React.FC<HighlightTermProps> = ({
    sentence,
    highlightTerm,
    HighlightComponent = DefaultHighlight,
}) => {
    if (!highlightTerm) {
        return <span>{sentence}</span>;
    }

    const sentenceParts = sentence.split(new RegExp(`(${escapeRegexString(highlightTerm)})`, "gi"));

    const jsxElements = sentenceParts.map((part, index) => {
        const shouldBeHighlighted = part.toLowerCase() === highlightTerm.toLowerCase();
        if (shouldBeHighlighted) {
            return <HighlightComponent key={index}>{part}</HighlightComponent>;
        }
        return <span key={index}>{part}</span>;
    });

    return <span>{jsxElements}</span>;
};

export default HighlightTerm;
